import { createContext, useContext, useReducer, type ReactNode } from 'react'
import { consoleReducer, initialConsoleState } from './reducer'
import type { ConsoleState } from './types'
import type { ConsoleAction } from './actions'

interface ConsoleStateContextValue {
  state: ConsoleState
  dispatch: React.Dispatch<ConsoleAction>
}

const ConsoleStateContext = createContext<ConsoleStateContextValue | null>(null)

export function ConsoleStateProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(consoleReducer, initialConsoleState)
  return (
    <ConsoleStateContext.Provider value={{ state, dispatch }}>
      {children}
    </ConsoleStateContext.Provider>
  )
}

export function useConsoleState(): ConsoleStateContextValue {
  const ctx = useContext(ConsoleStateContext)
  if (!ctx) {
    throw new Error('useConsoleState must be used inside ConsoleStateProvider')
  }
  return ctx
}
